import { CardContentResetPasswordCode } from "@warden-ui/card-components";
import { useAuth } from "@warden-ui/common";
import { parseQueryString, parseAmplifyConfig } from "@warden-ui/common";
import { Navigate,  useNavigate,  useSearchParams } from "react-router-dom";
import { cloneSearchParams } from "@warden-ui/common";
import { useState } from "react";
import { CPPageBody } from "@warden-ui/common-components";
import { useTranslation } from "react-i18next";

const defaultQueryString: {[key: string]: string} = {
  region: "",
  email: "",
  clear: "false",
}

export default function ResetPasswordCode() {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const queryString = parseQueryString(searchParams, defaultQueryString);
  const amplifyConfig = parseAmplifyConfig(queryString);
  auth.configureAmplify(amplifyConfig);

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const configureFailed = () => {
    if (!auth.isConfigured) {
      console.error("Auth is not configured.");
      return true;
    }
    return false;
  }
  
  if (queryString.email === "") {
    return <Navigate to="/" replace={true}/>;
  }

  const onClickSendCode = async (code: string) => {
    if (configureFailed()) {
      return;
    }

    if (code.length === 0) {
      setErrorMessage(t('digit_code.error.empty'));
      return;
    }

    if (code.length !== 6) {
      setErrorMessage(t('digit_code.error.short'));
      return;
    }

    setLoading(true);
    const result = await auth.confirmVerificationCode(queryString.email, code, amplifyConfig);
    if (result.success) {
      const params = cloneSearchParams(searchParams);
      params.set("verfication_code", code);

      navigate(`/reset_password/submit?${params.toString()}`);
    } else {
      if (result.message.includes("Invalid verification code provided")) {
        setErrorMessage(t('digit_code.error.failed'));
      } else {
        setErrorMessage(result.message);
      }
    }
    setLoading(false);
  };

  return (
    <CPPageBody
      onBackClicked={() => {
        navigate(`/?${searchParams.toString()}`);
      }}
    >
      <CardContentResetPasswordCode
        email={queryString.email}
        teamDomain={queryString.team_domain}
        onClickSendCode={onClickSendCode}
        errorMessage={errorMessage}
        loading={loading}
      />
    </CPPageBody>
  );
}